import { catchError, from, map, Observable, tap } from 'rxjs';
import { AxiosError, AxiosResponse } from 'axios';

import APIAxios, { APIRoutes } from '@api/axios.api';
import SnackError from '@utils/error.utils';
import {suppliersUnitsDetailsStore} from '@store/suppliers/units/details/suppliers-units-details.store';
import {SuppliersUnit} from '@store/suppliers/units';
import {getSupplierUnitDetailsDataSource} from '@store/suppliers/units/details/suppliers-units-details.requests';

export class SuppliersUnitsDetailsService {
  store = suppliersUnitsDetailsStore;

  resetStore = () => this.store.reset();

  getSupplierUnitById = (supplierUnitId: number | string): Observable<SuppliersUnit> => {
    return from(APIAxios(APIRoutes.GETSupplierUnitById(supplierUnitId)))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<SuppliersUnit>) => {
          return response.data;
        }),
        tap((supplierUnit) =>
          this.store.update((state) => ({
              ...state,
              ...supplierUnit,
            }),
            getSupplierUnitDetailsDataSource.setSuccess(),
          )
        ),
          getSupplierUnitDetailsDataSource.trackRequestStatus(),
      );
  };
}

export const supplierUnitsDetailsService = new SuppliersUnitsDetailsService();
